export default {
  select_size: 'Vælg en størrelse',
  required: 'Påkrævet',
  required_missing: 'Påkrævet — foretag et valg',
  optional: 'Valgfrit',
  select_up_to: 'Vælg op til {{maxCount}}',
};
